import { render } from "./ambiente-professor-layout.vue?vue&type=template&id=f7257778"
import script from "./ambiente-professor-layout.vue?vue&type=script&lang=js"
export * from "./ambiente-professor-layout.vue?vue&type=script&lang=js"

import "./ambiente-professor-layout.vue?vue&type=style&index=0&id=f7257778&lang=scss"
import "./ambiente-professor-layout.vue?vue&type=style&index=1&id=f7257778&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__